import React from 'react';
import DynamicImage from '../DynamicImage/DynamicImage';
import DynamicImageIcon from '../DynamicImageIcon/DynamicImage';
import './LoadingScreen.scss';

const LoadingScreen = (): React.ReactElement => {
  return (
    <div className="loading-screen">
      <DynamicImageIcon imageName="footer-logo" alt="Loading Explora" />
    </div>
  );
};

export default LoadingScreen;
